import { IFieldDefinitionLogic } from '../../../interfaces/ifield-definition-logic.interface';
import { TextFieldDefinitionLogicBase } from './text-logic-base';

// There is no logic, but the simplest way to set this up was to just extend a base class which already implements IFieldDefinitionLogic
export class FlexFieldButtonsFieldLogic extends TextFieldDefinitionLogicBase implements IFieldDefinitionLogic {

}
